import React from "react";

import { useGetCurrentCompanyApplicationQuery } from "EmployerApplication/api";
import { dollarDisplay } from "EmployerApplication/CostEstimationUtils";

import { Body1, Body2, SubBody } from "Cobalt/BodyText";
import { Table, TH, TD, TR, TDFoot, ExpandingRow } from "Cobalt/Table";
import { Row, Col } from "Common/Grid";
import { Div } from "Common/HTML";
import { SizeSwitch } from "Common/Responsive";

import makeBem from "Utils/makeBem";

const bem = makeBem("DisabilityCostBreakdownBody");

const MobileTable = ({ employees }) => (
  <Table>
    <thead>
      <TR>
        <TH>Employee</TH>
        <TH>Age</TH>
        <TH />
      </TR>
    </thead>
    <tbody className={bem()}>
      {employees.map((employee, index) => (
        <ExpandingRow
          key={index}
          mainContent={
            <>
              <TD width={140}>{employee.name}</TD>
              <TD>{employee.age}</TD>
            </>
          }
          expandingContent={
            <TR>
              <TD>Total Cost</TD>
              <TD className="text-right">{dollarDisplay(employee.employeeCost || null)}</TD>
              <TD />
            </TR>
          }
        />
      ))}
    </tbody>
  </Table>
);

const DesktopTable = ({ employees, totalCost }) => (
  <Table>
    <thead>
      <TR>
        <TH>Employee</TH>
        <TH>Age</TH>
        <TH />
        <TH className="text-right">Total Cost</TH>
      </TR>
    </thead>
    <tbody className={bem()}>
      {employees.map((employee, index) => (
        <TR key={index}>
          <TD>{employee.name}</TD>
          <TD>{employee.age}</TD>
          <TD />
          <TD className="text-right">{dollarDisplay(employee.employeeCost || null)}</TD>
        </TR>
      ))}
    </tbody>
    <tfoot>
      <TR>
        <TDFoot colSpan={3} />
        <TDFoot className="text-right">{dollarDisplay(totalCost)}</TDFoot>
      </TR>
    </tfoot>
  </Table>
);

export default function DisabilityCostBreakdownBody({ plan }) {
  const { data: companyApplication } = useGetCurrentCompanyApplicationQuery();
  const { employeeProfile } = companyApplication;
  const { employee_costs: employeeCosts } = plan;
  const fullTimeEmployeeCosts = employeeCosts.filter((employee) => employee.full_time);
  const totalCost = plan?.total_cost;
  const fullTimeEmployees = employeeProfile.filter((employee) => employee.fullTime);
  const employees = fullTimeEmployees.map((employee, index) => ({
    ...employee,
    employeeCost: fullTimeEmployeeCosts[index].composite_cost,
  }));
  return (
    <>
      <Row pb={4}>
        <SizeSwitch
          xs={
            <>
              <Col sm={8}>
                <Body2 weight="bold">You Pay {plan?.carrier}</Body2>
              </Col>
              <Col xs={12}>
                <Body2 pt={1}>
                  {dollarDisplay(totalCost)}
                  <Div pl={2} className={bem("perMonth")}>
                    Per Month
                  </Div>
                </Body2>
              </Col>
            </>
          }
          sm={
            <>
              <Col sm={8}>
                <Body1 weight="bold">You Pay {plan?.carrier}</Body1>
              </Col>
              <Col sm={4}>
                <Body2 className="text-right" weight="bold">
                  {dollarDisplay(totalCost)}
                  <Div pl={2} className={bem("perMonth")}>
                    Per Month
                  </Div>
                </Body2>
              </Col>
            </>
          }
        />
      </Row>
      <Row pb={2}>
        <Col xs={12} sm={8}>
          <SubBody pb={2} mb={4}>
            All Disability Insurance plans require that the monthly premium is 100% covered by the employer.
          </SubBody>
        </Col>
      </Row>
      <SizeSwitch xs={<MobileTable employees={employees} />} sm={<DesktopTable employees={employees} totalCost={totalCost} />} />
    </>
  );
}
